export const translations = {
  fr: {
    nav: {
      pastries: 'Nos pâtisseries',
      pates: 'Nos pâtes',
      history: 'Notre histoire',
      savoirfaire: 'Le savoir-faire',
      contact: 'Contact',
      cta: 'Nous contacter',
      since: 'Depuis 1985'
    },
    hero: {
      eyebrow: 'Depuis 1985 — Feuilletées & Pâtisseries · Fabrication Française',
      t1: 'Le feuilletage',
      t2: 'est notre',
      heritage: 'héritage',
      t3: ', depuis 1985.',
      desc: 'Spécialisée dans la fabrication des produits typiques de la cuisine méditerranéenne : pâte à filo (phyllo), pâte à kadayif, yufka, üçgen yufka — de véritables alternatives aux pâtes ménagères classiques. Pâtisseries orientales fabriquées par nos artisans : baklava, kadayif, şekerpare… Autant de saveurs à découvrir sur notre site internet.',
      cta1: 'Découvrir nos pâtisseries',
      cta1b: 'Découvrir nos pâtes',
      cta2: 'Notre histoire'
    },
    pastries: {
      eyebrow: 'Nos Pâtisseries',
      t1: '10 créations,',
      t2: 'un savoir-faire.',
      desc: 'Chaque pâtisserie est fabriquée en France par nos artisans, à partir de matières premières sélectionnées avec soin.',
      fiche: 'Fiche'
    },
    pates: {
      eyebrow: 'Nos Pâtes',
      t1: 'Le feuilletage,',
      t2: 'feuille après feuille.',
      desc: 'L’Atelier de Murat partage les saveurs de la cuisine méditerranéenne au plus grand nombre à travers la fabrication de pâtes typiques de cette tradition. De véritables alternatives aux pâtes ménagères classiques, pensées pour faire découvrir des textures, des formes et des saveurs authentiques.',
      fiche: 'Fiche',
      atm: 'Conditionné sous atmosphère protectrice',
      cold: 'Conservation +4°C / +8°C',
      halal: 'Halal certifié'
    },
    history: {
      eyebrow: 'Notre Histoire',
      t1: 'Une histoire',
      t2: 'de savoir-faire.'
    },
    savoir: {
      eyebrow: 'Le Savoir-Faire',
      t1: 'La qualité,',
      t2: 'à chaque étape.',
      desc: 'Toutes les pâtisseries que vous dégusterez sont fabriquées en France par nos artisans pâtissiers, selon une recette unique.',
      i1t: 'Matières premières sélectionnées',
      i1d: 'Pistaches d’Antep, noix de cajou du Brésil, noix de France : chaque ingrédient est choisi avec le plus grand soin.',
      i2t: 'Contrôles & traçabilité',
      i2d: 'Des contrôles qualité à chaque étape de fabrication et une traçabilité complète des produits finis.',
      i3t: 'Des partenaires historiques',
      i3d: 'Des partenaires ancrés dans l’histoire de notre entreprise, pour une qualité constante année après année.',
      madeIn: 'Fabriqué en France',
      ingredients: 'Nos ingrédients d’exception',
      pistachio: 'Pistaches d’Antep',
      cashew: 'Noix de cajou du Brésil',
      walnut: 'Noix de France',
      almond: 'Amandes'
    },
    formats: {
      eyebrow: 'Formats & Boîtes',
      t1: 'Deux formats,',
      t2: 'toutes les occasions.',
      l1: 'La découverte',
      t1n: 'Petite Boîte',
      d1: 'De 6 à 20 pièces selon la pâtisserie — le format idéal pour découvrir ou offrir.',
      l2: 'Le partage',
      t2n: 'Grande Boîte',
      d2: 'De 14 à 40 pièces selon la pâtisserie — pour les familles, les tables et les célébrations.'
    },
    contact: {
      eyebrow: 'Contact',
      t1: 'Venez nous',
      t2: 'rencontrer.',
      desc: 'Grossistes, distributeurs, restaurateurs ou simples gourmands — notre équipe vous répond avec plaisir.',
      address: 'Adresse',
      phone: 'Téléphone',
      website: 'Site web',
      follow: 'Suivez-nous',
      formTitle: 'Envoyez-nous un message',
      name: 'Nom',
      namePh: 'Votre nom',
      email: 'Email',
      emailPh: 'votre@email.com',
      message: 'Message',
      messagePh: 'Votre message',
      send: 'Envoyer',
      required: 'Champs requis',
      requiredDesc: 'Merci de remplir tous les champs.',
      sent: 'Message envoyé',
      sentDesc: 'Nous vous répondrons sous peu.',
      error: "Échec de l'envoi",
      errorDesc: 'Merci de réessayer ou de nous appeler directement.',
      directions: 'Itinéraire',
      hoursTitle: 'Horaires d’ouverture',
      hoursLine: 'Lundi au samedi · 9h – 18h',
      hoursSub: 'Accueil libre pendant les heures d’ouverture',
      hoursClosed: 'Fermé le dimanche',
      footer: 'Fabrication française'
    },
    modal: {
      pate: 'Pâte traditionnelle',
      pastry: 'Pâtisserie orientale',
      ingredients: 'Ingrédients',
      nutrition: 'Valeurs nutritionnelles',
      per100: 'pour 100 g',
      allergens: 'Allergènes',
      conditioning: 'Conditionnement',
      energy: 'Énergie',
      fat: 'Matières grasses',
      sat: 'Dont saturées',
      carbs: 'Glucides',
      sugars: 'Dont sucres',
      protein: 'Protéines',
      salt: 'Sel',
      shelf: 'Durée de conservation',
      storage: 'Stockage & transport',
      packaging: 'Emballage',
      cartons: 'Carton',
      pallet: 'Palette',
      pb: 'Petite boîte',
      gb: 'Grande boîte',
      tgb: 'Très grande boîte',
      halal: 'Halal certifié',
      madeFr: 'Fabrication française',
      atm: 'Sous atmosphère protectrice',
      close: 'Fermer'
    },
    page: {
      catPast: 'Catalogue · Pâtisseries orientales',
      catPastT1: 'Nos',
      catPastT1b: 'pâtisseries',
      catPastT2: ', façonnées à la main.',
      catPastDesc: 'Dix créations traditionnelles élaborées en France par nos artisans pâtissiers, à partir de pistaches d’Antep, noix de cajou du Brésil et noix de France sélectionnées avec soin.',
      catPates: 'Catalogue · Pâtes feuilletées',
      catPatesT1: 'Nos',
      catPatesT1b: 'pâtes',
      catPatesT2: ', feuille après feuille.',
      catPatesDesc: 'Une gamme de pâtes traditionnelles — filo, kadaïf, saç yufka, üçgen yufka, uzun yufka — destinée aux professionnels de l’agroalimentaire, de la restauration et de la pâtisserie.'
    },
    marquee: ['Depuis 1985', 'Fabrication française', 'Pistaches d’Antep', 'Noix de cajou du Brésil', 'Noix de France']
  },
  en: {
    nav: {
      pastries: 'Our pastries',
      pates: 'Our dough',
      history: 'Our story',
      savoirfaire: 'Craftsmanship',
      contact: 'Contact',
      cta: 'Contact us',
      since: 'Since 1985'
    },
    hero: {
      eyebrow: 'Since 1985 — Puff pastry & Oriental sweets · Made in France',
      t1: 'Puff pastry',
      t2: 'is our',
      heritage: 'heritage',
      t3: ', since 1985.',
      desc: 'Specialised in crafting the iconic products of Mediterranean cuisine: filo (phyllo), kadayif, yufka and üçgen yufka doughs — true alternatives to classic home-made pastry. Oriental pastries handmade by our artisans: baklava, kadayif, şekerpare… so many flavours to discover on our website.',
      cta1: 'Discover our pastries',
      cta1b: 'Discover our dough',
      cta2: 'Our story'
    },
    pastries: {
      eyebrow: 'Our Pastries',
      t1: '10 creations,',
      t2: 'one craft.',
      desc: 'Each pastry is handmade in France by our artisans, from carefully selected raw ingredients.',
      fiche: 'Details'
    },
    pates: {
      eyebrow: 'Our Dough',
      t1: 'Puff pastry,',
      t2: 'sheet after sheet.',
      desc: 'Atelier de Murat shares the flavours of Mediterranean cuisine by crafting the doughs that are iconic to this tradition — true alternatives to classic home-made pastry, designed to let everyone discover authentic textures, shapes and tastes.',
      fiche: 'Details',
      atm: 'Packaged under protective atmosphere',
      cold: 'Store at +4°C / +8°C',
      halal: 'Halal certified'
    },
    history: {
      eyebrow: 'Our Story',
      t1: 'A story',
      t2: 'of craftsmanship.'
    },
    savoir: {
      eyebrow: 'Craftsmanship',
      t1: 'Quality,',
      t2: 'at every step.',
      desc: 'Every pastry you’ll enjoy is handmade in France by our artisan pastry chefs, following a unique recipe.',
      i1t: 'Hand-picked raw ingredients',
      i1d: 'Antep pistachios, Brazilian cashews, French walnuts: every ingredient is selected with the greatest care.',
      i2t: 'Controls & traceability',
      i2d: 'Quality controls at every production step and full traceability on all finished products.',
      i3t: 'Long-standing partners',
      i3d: 'Partners rooted in our company’s history, for consistent quality year after year.',
      madeIn: 'Made in France',
      ingredients: 'Our premium ingredients',
      pistachio: 'Antep Pistachios',
      cashew: 'Brazilian Cashews',
      walnut: 'French Walnuts',
      almond: 'Almonds'
    },
    formats: {
      eyebrow: 'Formats & Boxes',
      t1: 'Two formats,',
      t2: 'every occasion.',
      l1: 'The discovery',
      t1n: 'Small Box',
      d1: 'From 6 to 20 pieces depending on the pastry — the perfect format to try or to gift.',
      l2: 'The sharing',
      t2n: 'Large Box',
      d2: 'From 14 to 40 pieces depending on the pastry — for families, tables and celebrations.'
    },
    contact: {
      eyebrow: 'Contact',
      t1: 'Come visit',
      t2: 'our atelier.',
      desc: 'Wholesalers, distributors, restaurateurs or simply food lovers — our team will be happy to answer.',
      address: 'Address',
      phone: 'Phone',
      website: 'Website',
      follow: 'Follow us',
      formTitle: 'Send us a message',
      name: 'Name',
      namePh: 'Your name',
      email: 'Email',
      emailPh: 'your@email.com',
      message: 'Message',
      messagePh: 'Your message',
      send: 'Send',
      required: 'Required fields',
      requiredDesc: 'Please fill in all fields.',
      sent: 'Message sent',
      sentDesc: 'We will get back to you shortly.',
      error: 'Sending failed',
      errorDesc: 'Please try again or call us directly.',
      directions: 'Get directions',
      hoursTitle: 'Opening hours',
      hoursLine: 'Monday to Saturday · 9am – 6pm',
      hoursSub: 'Walk in during opening hours — no appointment needed',
      hoursClosed: 'Closed on Sunday',
      footer: 'Made in France'
    },
    modal: {
      pate: 'Traditional dough',
      pastry: 'Oriental pastry',
      ingredients: 'Ingredients',
      nutrition: 'Nutrition facts',
      per100: 'per 100 g',
      allergens: 'Allergens',
      conditioning: 'Packaging',
      energy: 'Energy',
      fat: 'Fat',
      sat: 'of which saturates',
      carbs: 'Carbohydrates',
      sugars: 'of which sugars',
      protein: 'Protein',
      salt: 'Salt',
      shelf: 'Shelf life',
      storage: 'Storage & transport',
      packaging: 'Packaging',
      cartons: 'Carton',
      pallet: 'Pallet',
      pb: 'Small box',
      gb: 'Large box',
      tgb: 'Extra-large box',
      halal: 'Halal certified',
      madeFr: 'Made in France',
      atm: 'Protective atmosphere',
      close: 'Close'
    },
    page: {
      catPast: 'Catalogue · Oriental pastries',
      catPastT1: 'Our',
      catPastT1b: 'pastries',
      catPastT2: ', handcrafted with care.',
      catPastDesc: 'Ten traditional creations handmade in France by our artisan pastry chefs, from carefully selected Antep pistachios, Brazilian cashews and French walnuts.',
      catPates: 'Catalogue · Puff pastry doughs',
      catPatesT1: 'Our',
      catPatesT1b: 'doughs',
      catPatesT2: ', sheet after sheet.',
      catPatesDesc: 'A range of traditional doughs — filo, kadaïf, saç yufka, üçgen yufka, uzun yufka — crafted for professionals in the food industry, catering and pastry trades.'
    },
    marquee: ['Since 1985', 'Made in France', 'Antep Pistachios', 'Brazilian Cashews', 'French Walnuts']
  }
};

export const timelineI18n = {
  fr: [
    { year: '1985', title: 'La fondation', text: 'L’Atelier de Murat voit le jour avec l’ambition de partager les saveurs authentiques de la cuisine méditerranéenne et de faire vivre un savoir-faire traditionnel.' },
    { year: '2014', title: 'Le renouveau', text: 'Renouvellement complet de notre outil industriel : la tradition artisanale rencontre l’exigence moderne, sans jamais renier la recette unique.' },
    { year: 'Aujourd’hui', title: 'Partout en France', text: 'Depuis plus de 20 ans l’atelier de Murat s’efforce de proposer aux grossistes, aux enseignes de la distribution, aux professionnels de la restauration et aux consommateurs des pâtisseries de très grande qualité.' }
  ],
  en: [
    { year: '1985', title: 'The founding', text: 'Atelier de Murat was born with the ambition to share the authentic flavours of Mediterranean cuisine and to keep a traditional craft alive.' },
    { year: '2014', title: 'A new chapter', text: 'A complete overhaul of our production facility: artisanal tradition meets modern standards, without ever changing our unique recipe.' },
    { year: 'Today', title: 'Across France', text: 'For over 20 years Atelier de Murat has been crafting high-quality pastries for wholesalers, retailers, restaurateurs and consumers alike.' }
  ]
};

export const patesI18n = {
  fr: {
    tags: ['Fines & croustillantes', 'Les cheveux d’anges', 'Pour toutes vos recettes de börek', 'Croustillantes & délicieuses', 'Prête à garnir'],
    subs: ['Baklava, beurek & croustillant', 'Cheveux d’ange', 'Pâte feuilletée pour préparation salée', 'Pâtes feuilletées pour préparations salées', 'Pâte longue pour préparations salées']
  },
  en: {
    tags: ['Thin & crispy', 'Angel hair', 'For every börek recipe', 'Crispy & delicious', 'Ready to fill'],
    subs: ['Baklava, börek & crunch', 'Angel hair', 'Puff pastry for savoury recipes', 'Pre-cut puff pastry for savoury dishes', 'Long dough for savoury rolls']
  }
};

export const pastriesSubsI18n = {
  fr: [
    'Noix de France ou Pistache d’Antep',
    'Noix',
    '100% Pistache d’Antep',
    'Noix de cajou ou Pistache d’Antep',
    'Noix de cajou ou Pistache',
    'Noix de cajou ou Pistache',
    'Noix de cajou & amande',
    'Amande fine',
    'Noix de cajou ou Pistache',
    'Farine, œufs & sirop'
  ],
  en: [
    'French Walnut or Antep Pistachio',
    'Walnut',
    '100% Antep Pistachio',
    'Cashew or Antep Pistachio',
    'Cashew or Pistachio',
    'Cashew or Pistachio',
    'Cashew & almond',
    'Fine almond',
    'Cashew or Pistachio',
    'Flour, eggs & syrup'
  ]
};
